import { hbs } from 'ember-cli-htmlbars';
export default hbs("<ul class=\"card-pay-balances-list\">\n  {{yield (component \'card-pay/balances-list/balance\')}}\n</ul>\n")